import { IconShow, MenuListItem } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useCardPinMenuButtonPresenter } from './useCardPinMenuButtonPresenter'

export interface ICardPinMenuButtonPresenterProps {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
}

export const CardPinMenuButtonPresenter = ({
  externalId,
  scaToken,
  onVerificationRequired,
}: ICardPinMenuButtonPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    commands: { openCardPinModal },
    states: { isDisabled },
  } = useCardPinMenuButtonPresenter({
    externalId,
    scaToken,
    onVerificationRequired,
  })

  return (
    <MenuListItem
      onClick={() => openCardPinModal()}
      text={intl.formatMessage(messages.showPinMenuListItemText)}
      icon={<IconShow />}
      disabled={isDisabled}
    />
  )
}
